import { Monitor, TrendingUp, Users } from 'lucide-react';
import { PROMO } from '@/constants/testIds';

const cards = [
  {
    testId: PROMO.card1,
    icon: Monitor,
    title: 'Automated Service Activation Programs',
    description: 'We specialize in creating, configuring, & managing telecommunications services to help you streamline development cycles and quickly enter the market. With ASAP we deliver winning business solutions by leveraging the best strategies and industry experts.',
  },
  {
    testId: PROMO.card2,
    icon: TrendingUp,
    title: 'Expert Strategies for Winning Results',
    description: 'Our team of BRM experts is dedicated to providing top-notch services tailored to your specific needs. Say goodbye to billing headaches — our comprehensive solutions are designed to streamline your processes, increase efficiency, and maximize revenue.',
  },
  {
    testId: PROMO.card3,
    icon: Users,
    title: 'Your Project, Our Expertise',
    description: 'With our vast experience in organizing projects efficiently based on customer needs, we can help you build a strong brand identity. We take pride in offering comprehensive support & product management services, handling new updates & features tailored to meet client requirements.',
  },
];

const PromoCards = () => {
  return (
    <section data-testid={PROMO.section} className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Bento Grid - Asymmetric Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* First card - spans 2 cols on md */}
          <div
            data-testid={cards[0].testId}
            className="md:col-span-2 lg:col-span-1 bg-surface border border-white/10 rounded-sm p-8 lg:p-10 card-hover group"
          >
            <div className="w-12 h-12 bg-amber/10 rounded-sm flex items-center justify-center mb-6 group-hover:bg-amber/20 transition-colors">
              <Monitor className="w-6 h-6 text-amber" />
            </div>
            <h3 className="font-heading text-xl font-bold text-white mb-4">{cards[0].title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{cards[0].description}</p>
          </div>

          {/* Second card */}
          <div
            data-testid={cards[1].testId}
            className="bg-surface border border-white/10 rounded-sm p-8 lg:p-10 card-hover group"
          >
            <div className="w-12 h-12 bg-amber/10 rounded-sm flex items-center justify-center mb-6 group-hover:bg-amber/20 transition-colors">
              <TrendingUp className="w-6 h-6 text-amber" />
            </div>
            <h3 className="font-heading text-xl font-bold text-white mb-4">{cards[1].title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{cards[1].description}</p>
          </div>

          {/* Third card */}
          <div
            data-testid={cards[2].testId}
            className="bg-surface border border-white/10 rounded-sm p-8 lg:p-10 card-hover group"
          >
            <div className="w-12 h-12 bg-amber/10 rounded-sm flex items-center justify-center mb-6 group-hover:bg-amber/20 transition-colors">
              <Users className="w-6 h-6 text-amber" />
            </div>
            <h3 className="font-heading text-xl font-bold text-white mb-4">{cards[2].title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{cards[2].description}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoCards;
